// src/lib/auswahllisten.js
// --- VORSCHLAGSLISTEN FUER DIE STAMMDATEN ------------------------------------
//
// Alle Listen sind VORSCHLAEGE, keine Vorgaben: Die Felder benutzen ComboInput
// (Liste zum Antippen, Eigenes bleibt tippbar). Grund: Tippen ist die
// fehleranfaelligste Eingabeart, aber die Wirklichkeit vor Ort haelt sich
// nicht an unsere Listen. Wer einen Sonderfall nicht eintragen kann, traegt
// am Ende gar nichts ein.
//
// Zusammengestellt am 03.09.2026 aus den 13 Altprotokollen und einer
// Herstellerrecherche; von Anna-Lena auf die tatsaechlich vorkommenden
// gekuerzt.

// --- Stationsgebäude ---------------------------------------------------------
// Gritec hiess bis Februar 2024 Betonbau -- in den Altprotokollen steht noch
// der alte Name. Beide gehoeren in die Liste, sonst findet der Monteur seine
// eigene Station nicht wieder.
export const STATIONS_HERSTELLER = [
  'Gritec',
  'Betonbau (jetzt Gritec)',
  'Scheidt',
  'Horstmann & Schwarz',
  'Grötz',
  'Wagner Schaltanlagen',
  'Ernst Wirth',
  'Kalchschmid',
];

// Gritec-Baureihe UK. Die X/XL-Varianten und die UeST-Ausfuehrungen
// (Uebergabestation) sind mit aufgefuehrt, weil sie auf dem Typenschild stehen.
export const STATIONS_TYPEN = [
  // 3-Kammer-System
  'UK 1700-28', 'UK 2000-28',
  'UK 2200-29 X', 'UK 2200-29 XL',
  'UK 2200-32 X', 'UK 2200-32 XL',
  'UK 2200-35 X', 'UK 2200-35 XL',
  'UK 2200-36 X', 'UK 2200-36 XL',
  'UK 2600-35 X', 'UK 2600-35 XL',
  // 1-Kammer (Schaltstationen)
  'UK 1700-15', 'UK 2000-15', 'UK 2200-18 X', 'UK 2600-17 X',
  // dreiseitig bedienbar
  'UKL 2817', 'UKL 3119', 'UKL 3524 X', 'UKL 3524 XL',
  // zweiseitig bedienbar
  'UK 3015', 'UK 3015 (ÜST)',
  'UK 3615', 'UK 3615 (ÜST)',
  'UK 2820-1L', 'UK 2820 (ÜST)',
  'UK 3024-1L X', 'UK 3024 (ÜST) X',
  'UK 3224-1L X', 'UK 3224 (ÜST) X',
  'UK 3524-1L X', 'UK 3524 (ÜST) X',
];

// --- MS-Anlage ---------------------------------------------------------------
// Aus den Altprotokollen tatsaechlich vorgekommen, ergaenzt um die im
// deutschen Verteilnetz ueblichen Hersteller.
export const MS_HERSTELLER = [
  'Siemens', 'ABB', 'Ormazabal', 'Schneider Electric',
  'Driescher', 'Eaton', 'Ziegler Elektrotechnik', 'Wickmann',
];

// --- Transformator -----------------------------------------------------------
export const TRAFO_HERSTELLER = [
  'SGB', 'ABB', 'Siemens', 'AEG', 'Trafo Union',
  'France Transfo', 'Pauwels', 'TEK', 'Heim', 'Schneider Electric',
];

// Normreihe nach DIN 42500 / EN 50464. Sonderleistungen bleiben tippbar.
export const TRAFO_LEISTUNG_KVA = [
  '50', '75', '100', '160', '200', '250', '315', '400',
  '500', '630', '800', '1000', '1250', '1600', '2000', '2500',
];

// Oberspannung: im Verteilnetz ueblich. 24 und 36 sind Bemessungswerte der
// Anlage, nicht die Betriebsspannung -- deshalb hier nicht.
export const OS_SPANNUNG_KV = ['6', '10', '15', '20', '30'];
export const US_SPANNUNG_KV = ['0,4', '0,42', '0,69'];

// Schaltgruppen: In deutschen Verteilnetz-Trafos dominieren Dyn5 und Dyn11.
// Die uebrigen kommen bei aelteren oder Sonderanlagen vor.
export const SCHALTGRUPPEN = [
  'Dyn5', 'Dyn11', 'Dyn1',
  'Yzn5', 'Yzn11',
  'Yyn0', 'Dy5', 'Dy11', 'Yd5', 'Yd11', 'Dd0',
];

// --- Kabel -------------------------------------------------------------------
export const ADERANZAHL = ['0', '1', '2', '3', '4', '5'];

// Bauform der Station. Genau diese Werte laesst die Datenbank in
// station_konfiguration.stations_typ zu (Pruefregel aus Migration 2, seit
// Migration 43 mit Container und Baustromstation).
// Das ist seit 11.09.2026 das EINE Feld fuer die Bauform - siehe Migration 36.
export const BAUFORM = [
  { value: 'kompakt',     label: 'Kompaktstation' },
  { value: 'begehbar',    label: 'Begehbare Station' },
  { value: 'im_gebaeude', label: 'Trafostation im Gebäude' },
  { value: 'container',   label: 'Containerstation' },
  { value: 'baustrom',    label: 'Baustromstation' },
  { value: 'sonstige',    label: 'Sonstige' },
];
export const BAUFORM_TEXT = Object.fromEntries(BAUFORM.map(b => [b.value, b.label]));
export const BAUFORM_WERTE = BAUFORM.map(b => b.value);

// --- MS-Feldtypen ------------------------------------------------------------
// Recherche 15.09.2026: Siemens-Katalog 8DJH (R, T, L, S, V, M, E),
// Stromnetz Berlin TB3310 (Ringkabel-, Transformator-/Uebergabeschaltfeld,
// Messfeld), TAB Mittelspannung zur VDE-AR-N 4110 (Uebergabe-, Messfeld,
// Erzeugungsanlagen). Die Datenbank laesst genau diese Codes zu (Migration 43).
// kurz = Kennbuchstabe fuer Listen und PDF ("R – R – T – M").
// Frueher an drei Stellen einzeln gepflegt (Stammdaten, Protokoll, PDF).
export const MS_FELD_TYPEN = [
  { value: 'R',        kurz: 'R',  label: 'R – Ringkabelfeld' },
  { value: 'T',        kurz: 'T',  label: 'T – Trafofeld (Trafoabgang)' },
  { value: 'L',        kurz: 'L',  label: 'L – Leistungsschalterfeld' },
  { value: 'M',        kurz: 'M',  label: 'M – Messfeld' },
  { value: 'UE',       kurz: 'Ü',  label: 'Ü – Übergabefeld' },
  { value: 'K',        kurz: 'K',  label: 'K – Kabelanschlussfeld (ohne Schalter)' },
  { value: 'S',        kurz: 'S',  label: 'S – Längstrennfeld (Lasttrennschalter)' },
  { value: 'V',        kurz: 'V',  label: 'V – Kuppelfeld (Leistungsschalter)' },
  { value: 'E',        kurz: 'E',  label: 'E – Sammelschienen-Erdungsfeld' },
  { value: 'HF',       kurz: 'HF', label: 'HF – Hochführungsfeld' },
  { value: 'G',        kurz: 'G',  label: 'G – Einspeisefeld Erzeugungsanlage (PV, BHKW, Speicher)' },
  { value: 'sonstige', kurz: 'sonst.', label: 'Sonstiges Feld' },
];
export const MS_FELD_TEXT = Object.fromEntries(MS_FELD_TYPEN.map(f => [f.value, f.label]));
export const MS_FELD_KURZ = Object.fromEntries(MS_FELD_TYPEN.map(f => [f.value, f.kurz]));
// Nur der Name ohne Kennbuchstaben: "R – Ringkabelfeld" -> "Ringkabelfeld".
export const MS_FELD_NAME = Object.fromEntries(
  MS_FELD_TYPEN.map(f => [f.value, f.label.replace(/^[^–]*–\s*/, '')]));
// Was in Listen und im PDF als Bezeichnung steht: die eigene Bezeichnung, sonst
// der Feldtyp im Klartext (Anna-Lena 19.09.2026 - "nicht R-Ringfeld, nur Ringfeld").
export function msFeldBezeichnung(feld) {
  const eigen = String(feld?.bezeichnung || '').trim();
  if (eigen) return eigen;
  return MS_FELD_NAME[feld?.typ_code] || feld?.typ_code || 'Feld';
}

// --- Raeume der Station (Anna-Lena 18.09.2026, Migration 55) ---
// Nur bei begehbaren Stationen (nicht Kompaktstation). Daraus ergibt sich die
// Stueckzahl Isoliermatten (05.7): je MS-Raum, je NS-Raum und je kombiniertem
// MS/NS-Raum eine. Trafokammern zaehlen nicht.
export const RAUM_FELDER = [
  ['anzahl_ms_raeume', 'MS-Räume'],
  ['anzahl_ns_raeume', 'NS-Räume'],
  ['anzahl_ms_ns_raeume', 'MS/NS-Räume kombiniert'],
  ['anzahl_trafokammern', 'Traforäume / Trafokammern'],
];
export const RAUM_ANZAHL = Array.from({ length: 7 }, (_, k) => ({ value: String(k), label: String(k) }));
export function isoliermattenSoll(config) {
  if (!config || config.stations_typ === 'kompakt') return null;
  const werte = ['anzahl_ms_raeume', 'anzahl_ns_raeume', 'anzahl_ms_ns_raeume'].map(k => config[k]);
  if (werte.every(v => v == null || v === '')) return null;
  return werte.reduce((n, v) => n + (Number(v) || 0), 0);
}

// --- Trafo US-Anschluss mit / ohne Erdungsbolzen (Anna-Lena 18.09.2026, Migration 53) ---
// "Ohne Erdungsbolzen" ist ein Mangel: Pruefpunkt 04.3 (Erdung NS-Seite) wird
// automatisch n.i.O. (EditableStammdaten, TrafoErdungSync).
export const US_OHNE_ERDUNGSBOLZEN = ['kerzen_flach_ohne_eb', 'kerzen_fahne_ohne_eb', 'klemmen_ohne_eb', 'klemmen_hauben_ohne_kugel'];
export const US_MIT_ERDUNGSBOLZEN = ['kerzen_flach_eb', 'kerzen_fahne_eb', 'klemmen_eb', 'klemmen_hauben_kugel'];

